export const QUIZ_ANSWER_STATUSES = {
  CORRECT: 'Correct',
  INCORRECT: 'Incorrect',
};
